import { useEffect, useState } from "react";
import ContentHeader from "../../../components/shared/ContentHeader";
import { StyledOpenSign } from "./styles";
import OpenSignTable from "./Table";
import httpClient from "../../../api/httpClient";
import { parseError } from "../../../utils/shared";

const OpenSign = () => {
  const [templates, setTemplates] = useState([]);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setFetching(true);

        const { data } = await httpClient.get("opensign/templates");

        setTemplates(data);
      } catch (error) {
        parseError(error, true);
      } finally {
        setFetching(false);
      }
    };

    fetchTemplates();
  }, []);

  return (
    <StyledOpenSign>
      <ContentHeader title="Opensign Templates" />
      <OpenSignTable templates={templates} loading={fetching} />
    </StyledOpenSign>
  );
};

export default OpenSign;
